export default "__VITE_PUBLIC_ASSET__0ec5497e__"